import {clsx} from 'clsx'

import type {Label} from '../../../api/common-contracts'
import {LabelToken} from '../../fields/label-token'
import {DropdownCell} from './dropdown-cell'
import styles from './label-group.module.css'

interface LabelGroupProps {
  labels: Array<Label> | undefined
  dropdownRef?: React.RefObject<HTMLButtonElement | null>
  isDisabled?: boolean
  isWrapping?: boolean
}

export const LabelGroup: React.FC<LabelGroupProps> = ({labels, dropdownRef, isDisabled, isWrapping}) => {
  return (
    <DropdownCell ref={dropdownRef} isDisabled={isDisabled}>
      <div className={clsx(styles.Box, isWrapping && styles.wrapping)}>
        {labels?.map(label => (
          <LabelToken key={label.id} label={label} />
        ))}
      </div>
    </DropdownCell>
  )
}
